import React from 'react';
import ReactHtmlParser from 'react-html-parser'; 

class Toast extends React.Component { 
        
    handleCloseToast= () =>{
        this.props.closeToast();
    }
    
    render(){
        const { toastDescription, toastFlag, toastSuccess } = this.props;
       
        let toastClass    = (toastFlag===true) ? 'show' : 'hide';
        let toastIcon     = (toastSuccess===true) ? 'fas fa-circle' : 'fas fa-circle';
        let toastMsgClass = (toastSuccess===true) ? 'text-success text-white' : 'text-danger text-white';

        return (
      
            <div className={toastClass+" toast col-md-6 alert alert-secondary border alert-dismissible"} role="alert" aria-live="assertive" aria-atomic="true">
                <button type="button" className="close text-white" data-dismiss="toast" aria-label="Close" onClick={this.handleCloseToast}>
                ×</button>
                <span className={toastMsgClass}>
                    <small><i className={toastIcon}></i></small> {ReactHtmlParser(toastDescription)}
                </span>                      
            </div>
           
        );
    }

    
}
export default Toast;